namespace $.$$ {
	export class $shm_showcase_demo_tree extends $.$shm_showcase_demo_tree {
		items( id: string ) {
			return id === 'Компоненты' ? [ 'Telegram', 'Почта' ]
				: id === 'Telegram' ? [ 'Задачи', 'Комментарии', 'События' ] : []
		}
	}
}
